import { render, staticRenderFns } from "./DashboardCardPieChart.vue?vue&type=template&id=341fbcba&"
import script from "./DashboardCardPieChart.vue?vue&type=script&lang=ts&"
export * from "./DashboardCardPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCardPieChart.vue?vue&type=style&index=0&id=341fbcba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports